import sassJsonVariables from 'component-sass/_json_variables.sass.json';
import buttonGenerator from './generators/buttonGenerator';

const PrimaryButton = buttonGenerator(
    'Buttons/PrimaryButton',
    'button-primary',
    sassJsonVariables['tertiary-light'],
);

export default PrimaryButton;
